export enum AuthMethod {
  TOKEN_URL = "tokenUrl",
  USER_LOGGED_IN = "userLoggedIn",
  CONTA_INTELBRAS = "contaIntelbras",
}